import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 13/15;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 15 13" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.09.104a.35.35 0 00-.498 0L1.726 1.967l-.665-.65a.35.35 0 00-.498 0l-.46.462a.354.354 0 000 .5l1.395 1.395a.373.373 0 00.516 0l.456-.46L4.586 1.09a.357.357 0 00.002-.5L4.09.103zm0 4.685a.35.35 0 00-.498 0L1.726 6.664l-.665-.65a.35.35 0 00-.498 0l-.46.462a.354.354 0 000 .5l1.391 1.398a.373.373 0 00.516 0l.46-.462 2.115-2.125a.354.354 0 00.003-.498l-.498-.5zm-2.215 5.1c-.776 0-1.424.633-1.424 1.413s.648 1.413 1.424 1.413a1.41 1.41 0 001.406-1.413c0-.78-.63-1.412-1.406-1.412zm12.656.471H6.094a.47.47 0 00-.469.471v.942c0 .26.21.471.469.471h8.437a.47.47 0 00.469-.47v-.943a.47.47 0 00-.469-.47zm0-9.417H6.094a.47.47 0 00-.469.47v.942c0 .26.21.471.469.471h8.437a.47.47 0 00.469-.47v-.942a.47.47 0 00-.469-.471zm0 4.709H6.094a.47.47 0 00-.469.47v.942c0 .26.21.471.469.471h8.437a.47.47 0 00.469-.47v-.943a.47.47 0 00-.469-.47z" fill={color} fillRule="evenodd" />
    </svg>
)

export default class IconListChecks extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
